import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TalentAgency.graphql';
import { Query, QuerytalentAgencyArgs } from '../../__generated__/globalTypes';

export const useTalentAgencyQuery = (options?: QueryHookOptions<Query, QuerytalentAgencyArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytalentAgencyArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTalentAgencyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytalentAgencyArgs>
): QueryResult<Query, QuerytalentAgencyArgs> & {
  getTalentAgency: LazyQueryExecFunction<Query, QuerytalentAgencyArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTalentAgency, result] = useLazyQuery<Query, QuerytalentAgencyArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTalentAgency, ...result };
};

export const useTalentAgencyPromiseQuery = () => {
  const client = useApolloClient();

  const getTalentAgency = useCallback(
    (options?: Omit<QueryOptions<QuerytalentAgencyArgs, Query>, 'query'>) =>
      client.query<Query, QuerytalentAgencyArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTalentAgency };
};
// Suspense Query Hooks
export const useTalentAgencySuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QuerytalentAgencyArgs>) => {
  const result = useSuspenseQuery<Query, QuerytalentAgencyArgs>(QUERY, {
    ...options
  });

  return result;
};
